// src/store/networkErrorSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface NetworkErrorState {
  online: boolean
}

const initialState: NetworkErrorState = {
  online: true,
}

const networkErrorSlice = createSlice({
  name: 'networkError',
  initialState,
  reducers: {
    setOnline(state, action: PayloadAction<boolean>) {
      state.online = action.payload
    },
  },
})

export const { setOnline } = networkErrorSlice.actions
export default networkErrorSlice.reducer
